import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

/**
 * Initializes Google Analytics 4
 */
export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log("📊 GA4 Initialized");
  } else {
    console.warn("⚠️ GA4 Measurement ID missing in environment variables");
  }
};

/**
 * Tracks a pageview
 * @param path The URL path to track (e.g. /tools/pdf-to-word)
 */
export const trackPageView = (path: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

/**
 * Tracks a custom event
 * @param category Event category
 * @param action Event action
 * @param label Event label (optional)
 */
export const trackEvent = (category: string, action: string, label?: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};
